import { axios } from "../config";

export const createExam = (body) => {
  return axios.post("api/v1/exams", body);
};
export const updateExamination = (id, body) => {
  return axios.put(`api/v1/exams/${id}`, body);
};

export const getExamList = (data) => {
  return axios.get("api/v1/exams/list", {
  params: data 
  });
};

export const getSingleExamInfo = (params) => {
  return axios.get("api/v1/exams/exam-details", { params });
};

export const getAllSectionByLevel = (level_id, subject_id) => {
  return axios.get("api/v1/levels/section", {
    params: { level_id, subject_id },
  });
};

export const getLevelsBySubjects = (subject_id) => {
  return axios.get("api/v1/levels/by/subject/id", {
    params: { subject_id },
  });
};

export const getExamType = () => {
  return axios.get("/api/v1/exams/type");
};
export const setExam = (data) => {
  return axios.post("api/v1/exams/set/exam", data);
};

export const updateExam = (body) => {
  return axios.put("api/v1/exams/set/exam", body);
};

export const deleteExamSchedule = (id) => {
  return axios.delete(`api/v1/exams/set/exam/${id}`);
};

export const deleteExam = (id) => {
  return axios.delete(`api/v1/exams/${id}`);
};

export const getExamTeachers = (params) => {
  return axios.get("api/v1/exams/available/teacher/for/set/exams", {
    params,
  });
};

export const getRooms = (params) => {
  return axios.get("api/v1/rooms/available/rooms/for/set/exams", {
    params,
  });
};

export const freezeExam = (data) => {
  return axios.post("api/v1/exams/freeze", data);
};

export const sendExamTimeTable = (params) => {
  return axios.get("api/v1/exams/send-exam-time-table", { params });
};